import { styled } from "@mui/material";

export const ModalForm = styled("form")(() => ({
  height: "100%",
  "&:focus": {
    border: "none",
    outline: "none",
  },
}));
